import { SeatSellingMode } from './Event'

export enum SeatStatus {
    NotAvailable = 'not_available',
    Available = 'available',
    Reserved = 'reserved',
    Sold = 'sold',
    Complimentary = 'complimentary',
    Arrived = 'arrived',
    Selected = 'selected',
    InPayment = 'in_payment',
}
export interface Seat {
    seat_id?: string
    auditorium_id?: string
    gallery_id?: string | null
    row: number
    column: number
    on_gallery: boolean
}
export interface Gallery {
    gallery_id: string
    auditorium_id: string
    rows: number
    columns: number
    seats: Seat[]
    middle_column?: number
    gallery_name: string
}

export type AuditoriumType = 'location' | 'event_location'

export interface Auditorium {
    auditorium_id: string
    location_id?: string
    event_location_id?: string
    auditorium_type: AuditoriumType
    rows: number
    columns: number
    seats: Seat[]
    middle_column?: number
    gallery?: Gallery | null
}

export interface LocationType {
    location_id: string
    name: string
    address: string
    color: string
    org_id: string
    auditorium: Auditorium
    event_location_id?: string
    default_seat_selling_mode: SeatSellingMode
}

export interface CreateLocationDTO {
    location: Omit<LocationType, 'location_id' | 'color'> & {
        auditorium: Omit<Auditorium, 'auditorium_id' | 'location_id'> & {
            seats: Omit<Seat, 'seat_id' | 'auditorium_id'>[]
            gallery?: Omit<Gallery, 'gallery_id' | 'auditorium_id'> & {
                seats: Omit<Seat, 'seat_id' | 'auditorium_id'>[]
            }
        }
    }
}

export interface UpdateLocationDTO {
    locationId: string
    location: Partial<{
        name: string
        address: string
        color: string
        default_seat_selling_mode: SeatSellingMode
        auditorium: Partial<{
            rows: number
            columns: number
            middle_column?: number
            seats: Array<Partial<Seat>>
            gallery?: Partial<Gallery> & {
                seats: Array<Partial<Seat>>
            }
        }>
    }>
}
